import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent } from '@/hooks/useTracking';

export default function PageEngagement() {
  const location = useLocation();

  useEffect(() => {
    // Skip admin routes
    if (location.pathname.startsWith('/admin')) return;

    const startTime = Date.now();
    let maxScroll = 0;

    const handleScroll = () => {
      const docHeight = document.body.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;
      const scrollPct = Math.round((window.scrollY / docHeight) * 100);
      if (scrollPct > maxScroll) maxScroll = scrollPct;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      const duration = Math.round((Date.now() - startTime) / 1000);
      if (duration > 1) {
        trackEvent('page_engagement', {
          path: location.pathname,
          time_on_page_seconds: duration,
          max_scroll_depth_pct: maxScroll,
        });
      }
    };
  }, [location.pathname]);

  return null;
}
